<template>
  <div class="flex flex-col gap-2" @click.stop @mousedown.stop>
    <!-- Back Button (if showBackButton is true) -->
    <div
      v-if="showBackButton"
      class="flex items-center gap-2 px-2 py-2 cursor-pointer"
      @click="$emit('go-back')"
    >
      <ThemeImage
        :icon="imageNames.BACK_ARROW_WHITE"
        class="size-4"
        alt="go_back"
      />
      <span class="text-sm font-semibold text_color">Layout</span>
    </div>

    <div
      v-for="option in viewTypeOptions"
      :key="option.value"
      class="dropdown_item flex items-center gap-2 px-3 py-2 rounded-lg cursor-pointer"
      :class="{ selected_option: localViewType === option.value }"
      @click="selectViewType(option.value)"
    >
      <ThemeImage :icon="option.icon" :alt="option.alt" class="size-3" />
      <span class="text-sm">{{ option.label }}</span>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import ThemeImage from "@/src/components/ThemeImage.vue";
import { viewTypeOptions } from "@/src/constants/viewConstants.js";
import { imageNames } from "@/src/constants/imageConstants";

const props = defineProps({
  viewType: { type: String, default: "table" },
  showBackButton: { type: Boolean, default: false },
});

const emit = defineEmits(["update:viewType", "close", "go-back"]);

const localViewType = ref(props.viewType);

const selectViewType = (type) => {
  localViewType.value = type;
  emit("update:viewType", type);
  emit("close");
};

watch(
  () => props.viewType,
  (newVal) => {
    localViewType.value = newVal;
  },
);
</script>
